/* eslint-disable import/no-named-as-default-member */
import {
  BuyOrderType,
  SellOrderType,
} from 'global/Securities/types/transaction';
import create from 'zustand';

interface ITradingModalStoreState {
  visible?: boolean;
  symbol?: string;
  price?: number;
  orderType?: string;
  formType?: SellOrderType | BuyOrderType;
  showOrderbook?: boolean;
  showTabs?: boolean;
  showOrderType?: boolean;
  orderedLot?: number;
  orderid?: string;
  orderedPrice?: number;
  isAutoBuy?: boolean;
  modalData?: any;
  isDayTrade?: boolean;
  trailingStop?: SmartOrderTrailingStop;
  setToMaxLot?: boolean;
  isGtc?: number;
}

interface ITradingModalStoreAction {
  onClose?: () => void;
  showModal?: (any) => void;
  resetModal: () => void;
  setSymbol?(symbol: ITradingModalStoreState['symbol']): void;
  setOrderType?: (any) => void;
  setModalState: (payload: ITradingModalStoreState) => void;
  setAutoBuy?: (isAutoBuy: boolean) => void;
  setPrice: (price: number | null) => void;
}

type ITradingModalStore = ITradingModalStoreState & ITradingModalStoreAction;

const initialState = {
  visible: false,
  symbol: null,
  price: null,
  orderType: null,
  formType: null,
  showOrderbook: true,
  showTabs: false,
  showOrderType: false,
  orderedLot: null,
  orderid: null,
  orderedPrice: null,
  isAutoBuy: false,
  modalData: {},
  onClose: null,
  isDayTrade: false,
  trailingStop: undefined,
  setToMaxLot: false,
  isGtc: undefined,
};

const tradingModalStore = create<ITradingModalStore>((set) => ({
  ...initialState,
  setPrice: (price) => {
    set({ price });
  },
  showModal: (payload) => {
    set({ visible: true, ...payload });
  },
  setAutoBuy: (isAutoBuy: boolean) => {
    set({ isAutoBuy });
  },
  resetModal: () => {
    set(initialState);
  },
  setSymbol: (symbol) => {
    set({ symbol });
  },
  setOrderType: (type) => {
    set({ orderType: type });
  },
  setModalState: (payload) => {
    set({ ...payload });
  },
}));

export default tradingModalStore;
